import {
  createStatusBanner,
  deleteStatusBanner,
  getStatusBanner,
  updateStatusBanner
} from 'redux/api/internal/StatusBanner'
import { useThunkActions } from 'redux/actions/useThunkActions'

import { Dispatch } from 'redux'
import { StatusBannerBody } from 'utils/types'

import { toggleSnackbarOpen } from 'redux/actions/Snackbar'
import { SnackbarMessage } from 'types/GlobalSnackbar'

import * as actions from './actions'

export function tryGetInternalStatusBanner() {
  return (dispatch: Dispatch) => {
    dispatch(actions.getAll())

    getStatusBanner()
      .then((response) => {
        dispatch(actions.getAllSuccess(response.data))
      })
      .catch(() => {
        dispatch(actions.getAllFailed())
      })
  }
}

export function tryCreateStatusBanner(body: StatusBannerBody) {
  return (dispatch: Dispatch) => {
    dispatch(actions.create())

    createStatusBanner(body)
      .then((response) => {
        dispatch(actions.createSuccess(response.data))

        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))
      })
      .catch(() => {
        dispatch(actions.createFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.Failed))
      })
  }
}

export function tryUpdateStatusBanner(id: string, body: StatusBannerBody) {
  return (dispatch: Dispatch) => {
    dispatch(actions.update())

    updateStatusBanner(id, body)
      .then((response) => {
        dispatch(actions.updateSuccess(response.data))

        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))
      })
      .catch(() => {
        dispatch(actions.updateFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.Failed))
      })
  }
}

export function tryDeleteStatusBanner(id: string) {
  return (dispatch: Dispatch) => {
    dispatch(actions.destroy())

    deleteStatusBanner(id)
      .then(() => {
        dispatch(actions.destroySuccess({ id }))

        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))
      })
      .catch(() => {
        dispatch(actions.destroyFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.Failed))
      })
  }
}

export const useInternalStatusBannerActions = () => {
  return {
    tryGetInternalStatusBanner: useThunkActions(tryGetInternalStatusBanner),
    tryCreateStatusBanner: useThunkActions(tryCreateStatusBanner),
    tryUpdateStatusBanner: useThunkActions(tryUpdateStatusBanner),
    tryDeleteStatusBanner: useThunkActions(tryDeleteStatusBanner)
  }
}
